import ABCyaPhaser from "@abcya/abcya_phaser";
import { SavePrint } from "../SavePrint";
import { ChangeBackGroundFadeIn, ChangeBackGroundFadeOut, GroupTraySlide, TabTween, ToggleTrayItems, TraySlideOut, TweenInButtons } from "../TweensFile";
import FontKeys from "../../../FontKeys";
import ABCyaLib from "@abcya/abcya_lib";

export function OnPrintSaveClickHandler(Scene,SaveOrPrint)
{
    if(Scene.CleanUpHelp)
    {
        Scene.CleanUpHelp.destroy();
        Scene.CleanUpHelp = "";
    }

    const PrinSavGroup = Scene.add.group();
    const SnapShotGroup = Scene.add.group();

    let BackRect;
    let OverImage;
    let Logo;
    let CreatedByTxt;
    let PrintTextMessage;
    let PrintTextName;

    const BackGroundRect = Scene.add.rectangle(Scene.mid.x,Scene.mid.y,1024,768,0x000000,.5).setDepth(Scene.DepthList.HitBoxTree);
    const PopUp = Scene.addImage(686,Scene.mid.y,"Sv_Popup").setDepth(Scene.DepthList.DrawBlock);
    const AddYourNameTxt = ABCyaPhaser.Text.addText(460,187,24, 0xffffff, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("save_print_popup.add_your_name"), Scene).setOrigin(0).setDepth(Scene.DepthList.DrawBlock);
    const AddHolidayMsgTxt = ABCyaPhaser.Text.addText(460,279,24, 0xffffff, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("save_print_popup.add_a_holiday_message"), Scene).setOrigin(0).setDepth(Scene.DepthList.DrawBlock);
    const CloseX = Scene.addImage(903,195,"Sv_Btn_Cls").setDepth(Scene.DepthList.DrawBlock);
    const CheckBox = Scene.addImage(864,543,"Sv_Btn_Chk").setDepth(Scene.DepthList.DrawBlock);
    const Skip = Scene.addImage(518,543,"Sv_Btn_Skp").setDepth(Scene.DepthList.DrawBlock);
    const SkipTxt = ABCyaPhaser.Text.addText(518,540,ABCyaLib.Environment.instance.locale === ABCyaLib.Environment.LOCALES.esUS ? 24 : 28, 0xffffff, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("save_print_popup.skip_button"), Scene).setDepth(Scene.DepthList.DrawBlock);

    let PrintSaveArray = [BackGroundRect,CloseX,CheckBox,Skip];
    PrinSavGroup.addMultiple(PrintSaveArray);
    PrinSavGroup.add(PopUp);
    PrinSavGroup.add(AddYourNameTxt);
    PrinSavGroup.add(AddHolidayMsgTxt);
    PrinSavGroup.add(SkipTxt);

    for(let x in PrintSaveArray)
    {
        PrintSaveArray[x].setInteractive();
    }

    CheckBox.setInteractive();
    CloseX.setInteractive();

    Skip.on('pointerdown',()=>
    {
        Scene.AudioChan.Chan5.play('click_in_game');
        DispTextName.text = "";
		DispTextMessage.text = "";
        _setUpSnapShot();
    });

    CheckBox.on('pointerdown',()=>
    {
		Scene.AudioChan.Chan5.play('click_in_game');
        _setUpSnapShot();
        
    });

    CloseX.on('pointerdown',()=>
    {
		Scene.AudioChan.Chan5.play('click_in_game');
        _removePopUp();
        //ReturnFromSnapShot();
        //_snapShot();
    });

    const DispTextName = Scene.add.text(463,230,"",{fontFamily: 'asapregular',color: 0x045613, fontSize: 26}).setDepth(Scene.DepthList.DrawBlock);
    const DispTextMessage = Scene.add.text(463,311,"",{fontFamily: 'asapregular',color: 0x045613, fontSize: 26}).setDepth(Scene.DepthList.DrawBlock);

    DispTextName.setFixedSize(438,50);
    DispTextMessage.setFixedSize(440,198);
    DispTextMessage.setWordWrapWidth(440,true);

    // let TextIndi = Scene.add.rectangle(550,200,2,26,0x000000,1);
    // TextIndi.setDepth(Scene.DepthList.DrawBlock);
    // Scene.addTween(TextIndi,500,{alpha:0,yoyo:true,repeat:-1});

    const TextBox = document.getElementById('nametext');
    const MessageBox = document.getElementById('messagetext');
    TextBox.value = "";
    MessageBox.value = "";

    TextBox.oninput =async function (){
        //console.log("before wiat")
        TextBox.value = await _wordSearch(TextBox.value);
        //console.log("after wiat")
        DispTextName.text = TextBox.value;
        // TextIndi.x = DispTextName.getRightCenter().x;
        // //console.log(DispTextName.GetTextSize(DispTextName,DispTextName.getTextMetrics(),DispTextName.text));
    }
    MessageBox.oninput = function (){
        MessageBox.value = _wordSearch(MessageBox.value);
        DispTextMessage.text = MessageBox.value;
        //if(DispTextMessage.text < 15) DispTextMessage.advancedWordWrap(D)
    }

    TextBox.onfocus = function (){
        DispTextName.text = TextBox.value;
        NameClickBox.fillAlpha = .25;
    }
    MessageBox.onfocus = function (){
        DispTextMessage.text = MessageBox.value;
        MessageClickBox.fillAlpha = .25;
    }

    TextBox.onblur = function (){
        //DispTextName.text = TextBox.value;
        NameClickBox.fillAlpha = 0;
    }
    MessageBox.onblur = function (){
        //DispTextMessage.text = MessageBox.value;
        MessageClickBox.fillAlpha = 0;
    }

    let NameClickBox = Scene.add.rectangle(460,220,440,50,0x000000,0).setOrigin(0,0);
    NameClickBox.setInteractive();
    NameClickBox.setDepth(Scene.DepthList.DrawBlock+1);
    NameClickBox.input.alwaysEnabled = true;
    NameClickBox.on('pointerdown',()=>
    {
		MessageBox.blur();
        TextBox.focus();
    });

    let MessageClickBox = Scene.add.rectangle(459,310,442,198,0x000000,0).setOrigin(0,0);
    MessageClickBox.setInteractive();
    MessageClickBox.setDepth(Scene.DepthList.DrawBlock+1);
    MessageClickBox.input.alwaysEnabled = true;
    MessageClickBox.on('pointerdown',()=>
    {
		TextBox.blur();
        MessageBox.focus();
	});
	
    PrinSavGroup.addMultiple([NameClickBox,MessageClickBox,DispTextMessage,DispTextName]);
    
    async function _setUpSnapShot(Skip = false)
    {
        TweenInButtons(Scene.MenuButtons,400,Phaser.Math.Easing.Quadratic.Out,false);
        if(Scene.Tray.x > 208)
        {
            ToggleTrayItems(Scene.TrayGroup,false);
            GroupTraySlide(Scene.TrayGroup,"In");
            TabTween(Scene,Scene.HelpBtn,"In");
            TabTween(Scene,Scene.CloseTrayBtn,"In");
        }
        _removePopUp();
        await ChangeBackGroundFadeOut(Scene);
            if(Skip || ((DispTextMessage.text === "") && (DispTextName.text === "")))
            {
                //console.log("Short snap")
                _snapShot(true);
            }
            else
            {
                _snapShot();
            }
    }

    function _removePopUp()
    {
		TextBox.blur();
		MessageBox.blur();
        PrinSavGroup.clear(true,true);
    }

    function ReturnFromSnapShot()
    {
        let TweenTime = 200;
        //console.log("REturn from snap")

        if(PrintTextName)
        {
            Scene.addTween([PrintTextName,PrintTextMessage],TweenTime,{y:'+=300'},Phaser.Math.Easing.Quadratic.InOut);
        }
        Scene.addTween([Logo, CreatedByTxt],TweenTime,{y:'+=300'},Phaser.Math.Easing.Quadratic.InOut);
        Scene.addTween(OverImage,TweenTime,{scale:1,x:129},Phaser.Math.Easing.Quadratic.InOut,()=>{
            Scene.addTween(BackRect,TweenTime,{alpha:0},Phaser.Math.Easing.Quadratic.Out,()=>
            {
                SnapShotGroup.clear(true,true);
            });
            TweenInButtons(Scene.MenuButtons,400,Phaser.Math.Easing.Quadratic.Out);
            ChangeBackGroundFadeIn(Scene);
        });
    }

    function _snapShot(Skip = false)
    {
        Scene.game.renderer.snapshotArea(129, 0, Scene.game.canvas.width-130, Scene.game.canvas.height+100, (image)=>
        {
            if (Scene.textures.exists('snap'))
            {
                Scene.textures.remove('snap');
                Scene.textures.removeKey('snap');
            }
            Scene.textures.addBase64('snap',image.src);
            Scene.textures.once('addtexture',()=>
            {
                //OverImage = Scene.add.image(Scene.mid.x,Scene.mid.y,'snap');
                let secondTime = 100;
				let secondEase = Phaser.Math.Easing.Quadratic.InOut;
                if(Skip)
                {
                    let ScaleDown = .93;
                    let DropY = (768*ScaleDown);
                    BackRect = Scene.add.rectangle(-100,0,Scene.game.canvas.width+100, Scene.game.canvas.height,0xffffff).setAlpha(0);
                    BackRect.setOrigin(0,0);
                    OverImage = Scene.add.image(129,0,'snap').setOrigin(0,0);//.setScale(ScaleDown);
                    //OverImage.y -= DropY;
                    BackRect.setDepth(Scene.DepthList.DrawBlock);
                    OverImage.setDepth(Scene.DepthList.DrawBlock);

                    Scene.addTween(BackRect,300,{alpha:1,hold:30},Phaser.Math.Easing.Linear,()=>{
						let NameLoc = {x:Scene.mid.x,y:DropY};
						Logo = Scene.add.image(Math.round(NameLoc.x)+55,Math.round(NameLoc.y + 26),'UIAssets','ABCyaLogo').setDepth(Scene.DepthList.DrawBlock);
						Logo.setScale(.75);
            CreatedByTxt = ABCyaPhaser.Text.addText(495,733,18, 0x231f20, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("save_print_output.created_on"), Scene).setOrigin(1, 0).setDepth(Scene.DepthList.DrawBlock);
						let OverImageLocX = NameLoc.x - (OverImage.width*ScaleDown*.5);
						if(SaveOrPrint === "Print")OverImageLocX += 1;
                        //console.log(OverImageLocX);
                        Scene.addTween(OverImage,secondTime,{scale:ScaleDown,x:OverImageLocX},secondEase);
                        Scene.addTween(Logo,secondTime,{y:{start: Logo.y + (768 - DropY),end:Math.round(DropY)},hold: 10},secondEase,async ()=>{
							Logo.y = Math.round(Logo.y);
							OverImage.y = -1;
							await SavePrint(SaveOrPrint,Scene,Skip);
                            ReturnFromSnapShot();
                        });
                        SnapShotGroup.addMultiple([BackRect,OverImage,Logo, CreatedByTxt]);
                    });

                    
                }
                else
                {
                    let ScaleDown = .75;
                    let NameDropY = 140;
                    if(!DispTextMessage.text)
                    {
                        ScaleDown = .93;
                        NameDropY = 15;
                    }
                    let DropY = (768*ScaleDown);
                    let NameLoc = {x:Scene.mid.x,y:DropY};
                    let LogoLocation;
                    BackRect = Scene.add.rectangle(0,0,Scene.game.canvas.width, Scene.game.canvas.height,0xffffff).setAlpha(0);
                    BackRect.setOrigin(0,0);
                    OverImage = Scene.add.image(129,0,'snap').setOrigin(0,0);//.setScale(ScaleDown);
                    //OverImage.y -= DropY;
                    BackRect.setDepth(Scene.DepthList.DrawBlock);
                    OverImage.setDepth(Scene.DepthList.DrawBlock);
                    
                    PrintTextName = Scene.add.text(NameLoc.x+121,NameLoc.y+NameDropY,"",{fontFamily: 'asapregular',color: 0x045613, fontSize: 26,align: 'center'}).setDepth(Scene.DepthList.DrawBlock);
                    PrintTextMessage = Scene.add.text(NameLoc.x,NameLoc.y+10,"",{fontFamily: 'asapregular',color: 0x045613, fontSize: 24,align: 'center'}).setDepth(Scene.DepthList.DrawBlock);
                    PrintTextName.setAlpha(0);
                    PrintTextMessage.setAlpha(0);

                    if(DispTextName.text)
                    {
                        PrintTextName.text = " " + ABCyaPhaser.Localization.instance.getLocalizedString("save_print_output.by") + " " + DispTextName.text;
                    }
                    
                    PrintTextMessage.text = DispTextMessage.text;

                    PrintTextName.setOrigin(.5,0);
                    PrintTextMessage.setOrigin(.5,0);

                    if(PrintTextName.width >= 483)
                    {
                        LogoLocation = NameLoc.x - (483*.5);
                    }
                    else
                    {
                        LogoLocation = PrintTextName.x - (PrintTextName.width*.5) - 121;
                    }

                    //Logo = Scene.add.image(LogoLocation,NameLoc.y + NameDropY + 12,'UIAssets','ABCya').setDepth(Scene.DepthList.DrawBlock);

                    PrintTextName.setFixedSize(483,50);//Made larger for the added " by "
                    PrintTextMessage.setFixedSize(900,190);
                    PrintTextMessage.setWordWrapWidth(900,true);

                    Scene.addTween(BackRect,300,{alpha:1,hold:30},Phaser.Math.Easing.Linear,()=>{
                        let NameLoc = {x:Scene.mid.x,y:DropY};
                        Logo = Scene.add.image(Math.round(LogoLocation+55),Math.round(NameLoc.y + NameDropY + 12),'UIAssets','ABCyaLogo').setDepth(Scene.DepthList.DrawBlock).setScale(0.75);
                        CreatedByTxt = ABCyaPhaser.Text.addText(Logo.x-73,Logo.y-7,18, 0x231f20, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("save_print_output.created_on"), Scene).setOrigin(1, 0).setDepth(Scene.DepthList.DrawBlock);
						let OverImageLocX = NameLoc.x - (OverImage.width*ScaleDown*.5);
						if(SaveOrPrint === "Print")OverImageLocX += 6;
                        //console.log(OverImageLocX);
                        PrintTextName.setAlpha(1);
                        PrintTextMessage.setAlpha(1);
						Scene.addTween(OverImage,secondTime,{scale:ScaleDown,x:OverImageLocX},secondEase);
                        Scene.addTween(Logo,secondTime,{y:{start: Logo.x + (768 - DropY),end:Math.round(DropY)}},secondEase,()=>{Logo.y = Math.round(Logo.y)});
                        Scene.addTween(PrintTextName,secondTime,{y:{start: PrintTextName.y + (768 - DropY),end:PrintTextName.y}},secondEase);
                        Scene.addTween(PrintTextMessage,secondTime,{y:{start: PrintTextMessage.y + (768 - DropY),end:PrintTextMessage.y}},secondEase,async ()=>{
							OverImage.y = -1;
                            await SavePrint(SaveOrPrint,Scene);
                            //console.log("After print"),
                            ReturnFromSnapShot();
                        });
                        SnapShotGroup.addMultiple([BackRect,OverImage,Logo, CreatedByTxt,PrintTextMessage,PrintTextName]);
                    });
                }
            });
        });
    }
}

function _wordSearch(Text)
{
	return ABCyaLib.BadWordFilter.replaceBadWords(Text, '*', false);
}
